<template>
  <Modal
    id="forgot"
    buttonName="CLOSE"
    ref="modalForgot"
    title="Account recovery"
    @button="closeModal()"
    :materialButton="true"
  >
    <footer
      data-cy="forgotResponse"
      v-if="theResponse"
      class="h5 font-weight-normal register-response"
    >
      <h4>{{ responseTitle }}</h4>
      <span v-html="theResponse" />
      <span v-if="responseFooter && !emailResend">
        <strong>Didn't receive the email?</strong>
        Please check your spam folder, or click
        <a class="resend-email-link" @click.prevent="resendEmail">resend</a>
        and we'll send it again.
      </span>
      <span
        v-html="emailResend"
        class="the-email-resend"
        v-if="emailResend"
      ></span>
    </footer>
    <LoadingSpinner position="relative" v-else />
  </Modal>
</template>

<script>
import Modal from "@/components/atoms/Modal.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import { mapGetters } from "vuex";
export default {
  name: "ModalForgot",
  mixins: [UserHelperVue],
  components: {
    Modal,
    LoadingSpinner,
  },
  props: ["isForgotUsername", "isForgotPassword"],
  data() {
    return {
      emailResend: null,
    };
  },
  methods: {
    closeModal() {
      this.$refs.modalForgot.closeModal();
      this.resetResponse();
      this.emailResend = null;
    },
    resendEmail() {
      this.emailResend = "<br/><strong>Email successfully resent<strong/>";
      if (this.isForgotUsername) {
        this.$emit("forgotUsername");
      } else if (this.isForgotPassword) {
        this.$emit("forgotPassword");
      }
    },
  },
  computed: {
    ...mapGetters({
      response: "getRequestResponse",
    }),
    theResponse() {
      if (this.response.result) {
        if (
          this.response.result === "Invalid email." ||
          this.response.error === "Please provide an email."
        ) {
          return "This email address is not valid or not registered, please verify this information.";
        }
        if (this.response.error) {
          if (this.response.error === "Please provide a valid username") {
            return "This username is not valid or not registered, please verify this information.";
          }
          return this.response.error;
        } else if (
          this.response.result === "Password reset email sent." ||
          this.isForgotUsername ||
          this.isForgotPassword
        ) {
          let recoverInfo;
          if (this.isForgotUsername) {
            recoverInfo = "username";
          } else recoverInfo = "password";
          return `We've sent you an email with instructions for recovering your ${recoverInfo}.<br/> <br/>`;
        }
      }
      return "";
    },
    responseTitle() {
      if (this.response.error) return "Recovery error";
      else if (
        (this.response.result &&
          this.response.result === "Password reset email sent.") ||
        this.response.result.includes("Email was sent")
      ) {
        return "Please check your email";
      } else if (this.response.error === "Please provide a valid username") {
        return "Invalid username";
      } else if (
        this.response.error === "Please provide an email." ||
        this.response.result === "Invalid email"
      ) {
        return "Invalid email";
      }
      return this.response.result;
    },
    responseFooter() {
      if (this.response.result === undefined) {
        return false;
      }
      return !!(this.response.result &&
        (this.response.result === "Password reset email sent." ||
          this.response.result.includes("Email was sent")));
    },
  },
};
</script>

<style lang="scss" scoped>
.the-email-resend {
  color: $primary;
}
.resend-email-link {
  text-decoration: none !important;
  cursor: pointer;
  color: $primary;
}
.center-content-back {
  height: 20rem;
  margin-top: -20px;
}
</style>
